/**
 * StatisticCard - KPI stat with animated number, label, and icon.
 */
import React, { useEffect, useRef, useState } from 'react';

export interface StatisticCardProps {
  variant?: string;
  value: string | number;
  label: string;
  icon?: React.ReactNode;
  prefix?: string;
  suffix?: string;
  description?: string;
  className?: string;
}

const StatisticCard: React.FC<StatisticCardProps> = ({
  value, label, icon, prefix = '', suffix = '', description, className = '',
}) => (
  <div
    className={`metric-card ${className}`}
    role="figure"
    aria-label={`${label}: ${prefix}${value}${suffix}`}
  >
    {icon && <div style={{ fontSize: '2rem', marginBottom: 'var(--spacing-3)' }} aria-hidden="true">{icon}</div>}
    <div style={{ fontSize: 'clamp(2rem, 4vw, 3rem)', fontWeight: 'var(--font-weight-extrabold)', lineHeight: 1, marginBottom: 'var(--spacing-2)', color: '#ffffff' }}>
      <span aria-hidden="true">{prefix}</span>
      {value}
      <span aria-hidden="true">{suffix}</span>
    </div>
    <p style={{ fontWeight: 'var(--font-weight-semibold)', fontSize: 'var(--font-size-sm)', color: 'rgba(255,255,255,0.88)', marginBottom: description ? 'var(--spacing-2)' : 0 }}>
      {label}
    </p>
    {description && <p style={{ fontSize: 'var(--font-size-xs)', color: 'rgba(255,255,255,0.65)' }}>{description}</p>}
  </div>
);

export default StatisticCard;
